module.exports = __webpack_public_path__ + "static/media/user_input.5a4a683d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindHeat/user_input.png
// module id = 2519
// module chunks = 0